var ConditionlDelayBlockModel = /** @class */ (function () {
    function ConditionlDelayBlockModel(data) {
        if (data === void 0) { data = undefined; }
        this.col_name = '';
        this.event_method = 'pass on before';
        this.fieldLabel = '';
        this.interval = 0;
        this.type = 'conditional';
        this.unit = 'Hours';
        if (data) {
            for (var key in data) {
                if (this.hasOwnProperty(key)) {
                    this[key] = data[key];
                }
            }
        }
    }
    return ConditionlDelayBlockModel;
}());
export { ConditionlDelayBlockModel };
